<template>
  <div>
    <!-- Filtro de productos -->
    <v-expansion-panels focusable class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-header class="titulo_buscador">
          <span>
              <v-icon large>mdi-magnify</v-icon>
              {{ $t("Buscar") }}
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="ma-0" align="center">
            <v-col class="pb-0" cols="12" sm="4" md="2">
              <v-text-field
                :label="$t('Código de barras')"
                v-model="selected_filters.barcode"
                dense
                outlined
                @keyup.enter="filter_producto()"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col class="pb-0" cols="12" sm="4" md="2">
              <v-text-field
                  :label="$t('Referencia')"
                  v-model="selected_filters.ref"
                  dense
                  outlined
                  @keyup.enter="filter_producto()"
                  hide-details
              ></v-text-field>
            </v-col>
            <v-col class="pb-0" cols="12" sm="4" md="2">
              <v-text-field
                  :label="$t('Nombre')"
                  v-model="selected_filters.nombre"
                  dense
                  outlined
                  @keyup.enter="filter_producto()"
                  hide-details
              ></v-text-field>
            </v-col>
            <v-col class="pb-0" cols="12" sm="6" md="2">
              <CustomSelect
                  v-model="selected_filters.categoria"
                  :items="data_filters.categorias"
                  :label="$t('Categorías')"
                  :select_all="true"
                  :hide_details="true"
              />
            </v-col>
            <v-col class="pb-0" cols="12" sm="6" md="2">
              <v-select
                  :label="$t('Activo')"
                  v-model="selected_filters.is_active"
                  :items="data_filters.boolean_filter"
                  dense
                  outlined
                  clearable
                  hide-details
              ></v-select>
            </v-col>
            <v-col class="pb-0" cols="12" sm="6" md="2">
              <v-select
                  :label="$t('Bajo stock')"
                  v-model="selected_filters.is_bajo_stock"
                  :items="data_filters.boolean_filter"
                  dense
                  outlined
                  clearable
                  hide-details
              ></v-select>
            </v-col>
            <v-col v-if="!proveedor" class="pb-0" cols="12" sm="6" md="2">
              <CustomSelect
                  v-model="selected_filters.proveedor"
                  :items="data_filters.proveedores"
                  :label="$t('Proveedor')"
                  :select_all="true"
                  :hide_details="true"
              />
            </v-col>
            <v-col class="pb-0" cols="12" sm="6" md="2">
              <v-select
                :label="$t('Uso interno')"
                v-model="selected_filters.is_uso_interno"
                :items="data_filters.boolean_filter"
                dense
                outlined
                clearable
                hide-details
              ></v-select>
            </v-col>
            <v-col class="pb-0" cols="12" sm="6" md="2">
              <v-select
                :label="$t('Ecommerce')"
                v-model="selected_filters.is_disponible_ecommerce"
                :items="data_filters.boolean_filter"
                dense
                outlined
                clearable
                hide-details
              ></v-select>
            </v-col>
            <v-col class="text-end pb-0">
              <v-btn fab small right class="primary" @click="filter_producto()">
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-row class="ma-0" v-if="proveedor">
      <v-col cols="12" class="text-end">
        <v-btn
            color="primary"
            small
            v-if="$store.state.auth.user.tipo_empleado === 'admin'"
            @click="open_dialog_producto_proveedor"
        >
          {{ $t('Nuevo producto') }}
        </v-btn>
      </v-col>
    </v-row>

    <BuscadorTabla :label="$t('Introducir nombre, categoría, código de barras, referencia, etc.')" @search_general="filter_producto"/>

    <!-- Tabla de servicios -->
    <TablaProductos
        ref="tabla_productos"
        :selected_filters="selected_filters"
        @on_click_edit="open_dialog_producto"
    />

    <FormProducto
        v-if="dialog_producto"
        v-model="dialog_producto"
        :item="current_producto"
        @on_save="on_save_producto"
        @on_transfer="get_productos"
    />
  </div>
</template>

<script>

export default {
  name: "BuscarProductos",
  props: {
    proveedor: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      current_producto: null,
      dialog_producto: false,
      // Variables para rellenar los selects de los filtros
      data_filters: {
        categorias: [],
        proveedores: [],
        boolean_filter: [],
      },
      // Los filtros seleccionados
      selected_filters: {
        barcode: "",
        ref: "",
        nombre: "",
        categoria: [],
        proveedor: [],
        is_active: true,
        is_bajo_stock: null,
        is_uso_interno: null,
        is_disponible_ecommerce: null,
      },
    }
  },

  methods: {
    /**
     * Recupera los servicios de la api
     */
    async get_productos() {
      // Preparamos los filtros del buscador
      if (this.selected_filters['nombre'])
        this.selected_filters['search'] = this.selected_filters['nombre']
      if (this.selected_filters['ref'])
        this.selected_filters['search'] = this.selected_filters['ref']
      this.selected_filters['categoria__id__in'] = this.selected_filters['categoria'].join(",")

      if (this.proveedor) {
        this.selected_filters['proveedor'] = this.proveedor.id
        this.selected_filters['proveedor__id__in'] = [this.proveedor.id].join(",")
      } else {
        this.selected_filters['proveedor__id__in'] = this.selected_filters['proveedor'].join(",")
      }

      await this.$refs.tabla_productos.get_productos()
    },

    /**
     * Carga los selects para los filtros de la agenda
     * @returns {Promise<void>}
     */
    async get_filters() {
      let result = await this.$store.dispatch('producto/get_filters')
      this.data_filters.categorias = result.categorias
      this.data_filters.proveedores = result.proveedores
    },

    /**
     * Abre el formulario del producto
     */
    open_dialog_producto(item) {
      this.current_producto = null

      if(item){
        this.current_producto = { ...item }
        this.current_producto.categoria = item.categoria.id
      }

      this.dialog_producto = true
    },

    open_dialog_producto_proveedor(){
      this.current_producto = { proveedor: this.proveedor.id }
      this.dialog_producto = true
    },

    on_save_producto(){
      this.get_productos()
      this.dialog_producto = false
    },

    filter_producto(filter = null){
      if (filter !== null) {
        this.selected_filters['search'] = filter
      }
      this.$refs.tabla_productos.tabla.filtros['offset'] = 0
      this.$refs.tabla_productos.tabla.options.page = 1
      this.get_productos();
    }
  },

  // Observamos el campo
  watch: {
    'tabla.options': {
      handler(value, oldValue){
        if(value.itemsPerPage !== oldValue.itemsPerPage){
          try{
            localStorage.setItem('itemsPerPage', value.itemsPerPage)
          }catch (e){}
        }
        this.tabla.filtros['limit'] = value.itemsPerPage
        this.tabla.filtros['offset'] = ((value.page - 1) * value.itemsPerPage)
        if (value.sortBy.length) {
          let desc = value.sortDesc[0] === true ? '-' : ''
          this.tabla.filtros['ordering'] = `${desc}${value.sortBy[0]
              .split(".")
              .join("__")}`;
        }
        this.get_productos()
      },
    },
  },

  mounted() {
    if (this.proveedor) {
      this.selected_filters['proveedor'] = this.proveedor.id
      this.selected_filters['proveedor__id__in'] = [this.proveedor.id].join(",")
    }
    this.data_filters.boolean_filter = [
      { text: this.$t("Si"), value: true },
      { text: this.$t("No"), value: false }
    ]
    this.get_filters()
  },
  components: {
    BuscadorTabla: () => import('@/components/core/BuscadorTabla.vue'),
    FormProducto: () => import('@/views/Configuracion/Productos/Productos/components/FormProducto'),
    TablaProductos: () => import('@/views/Configuracion/Productos/Productos/components/TablaProductos')
  }
};
</script>
